import { api } from './api';

export const XAI_SPEECH_VOICES = [
  { id: 'eve', name: 'Eve', description: 'Balanced and clear' },
  { id: 'ara', name: 'Ara', description: 'Warm and steady' },
  { id: 'leo', name: 'Leo', description: 'Confident and direct' },
  { id: 'rex', name: 'Rex', description: 'Deep and assertive' },
  { id: 'sal', name: 'Sal', description: 'Friendly and conversational' },
];

export async function playSpeech({
  text,
  provider,
  browserVoiceId,
  xaiVoiceId,
  synth,
  audioRef,
  onStart,
  onEnd,
}) {
  const trimmed = (text || '').trim();
  if (!trimmed) return;

  if (provider === 'xai') {
    const blob = await api.synthesizeSpeech({
      text: trimmed,
      provider: 'xai',
      voice_id: xaiVoiceId || 'eve',
    });
    if (audioRef?.current) {
      audioRef.current.pause();
      if (audioRef.current.src) {
        URL.revokeObjectURL(audioRef.current.src);
      }
      audioRef.current = null;
    }
    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    if (audioRef) {
      audioRef.current = audio;
    }
    audio.onplay = () => onStart?.();
    audio.onended = () => {
      URL.revokeObjectURL(url);
      if (audioRef) {
        audioRef.current = null;
      }
      onEnd?.();
    };
    audio.onerror = () => {
      URL.revokeObjectURL(url);
      if (audioRef) {
        audioRef.current = null;
      }
      onEnd?.();
    };
    await audio.play();
    return;
  }

  if (!synth) return;
  synth.cancel();
  const utterance = new SpeechSynthesisUtterance(trimmed);
  utterance.rate = 0.98;
  utterance.pitch = 1;
  if (browserVoiceId && browserVoiceId !== 'default') {
    const voice = synth.getVoices().find((item) => item.voiceURI === browserVoiceId);
    if (voice) {
      utterance.voice = voice;
    }
  }
  utterance.onstart = () => onStart?.();
  utterance.onend = () => onEnd?.();
  utterance.onerror = () => onEnd?.();
  synth.speak(utterance);
}

export function stopSpeech({ provider, synth, audioRef, onEnd }) {
  if (provider === 'xai' && audioRef?.current) {
    const currentAudio = audioRef.current;
    currentAudio.pause();
    if (currentAudio.src) {
      URL.revokeObjectURL(currentAudio.src);
    }
    audioRef.current = null;
    onEnd?.();
    return;
  }
  synth?.cancel();
  onEnd?.();
}
